var map = {
	"./company_happytablebi.jpg": "2700",
	"./company_historybg.jpg": "ae9e",
	"./company_intro1.jpg": "232f",
	"./company_intro2.jpg": "5abc",
	"./company_intro3.jpg": "bd3c",
	"./company_logo1.jpg": "f682",
	"./company_logo2.jpg": "85ee",
	"./company_logo3.jpg": "2b9b",
	"./company_logo4.jpg": "611e",
	"./directions_map.jpg": "def5",
	"./gamemore_bg.jpg": "7879",
	"./happytable_bg.jpg": "19b8",
	"./happytable_info1.jpg": "aabc",
	"./happytable_info2.jpg": "e699",
	"./happytable_info3.jpg": "0192",
	"./happytable_info4.jpg": "c317",
	"./happytable_info5.jpg": "4157",
	"./happytable_product1.jpg": "4206",
	"./happytable_product2.jpg": "76f5",
	"./happytable_product3.jpg": "fe15",
	"./happytable_product4.jpg": "454c",
	"./m_main.jpg": "f19d",
	"./m_top_cognitive.jpg": "90a5",
	"./m_top_company.jpg": "2093",
	"./m_top_directions.jpg": "3d32",
	"./m_top_game.jpg": "93e8",
	"./m_top_happytable.jpg": "b01a",
	"./m_top_news.jpg": "c23b",
	"./m_top_overview.jpg": "f23e",
	"./m_top_partner.jpg": "5bb4",
	"./m_top_reference.jpg": "ec22",
	"./main_img.jpg": "d117",
	"./main_product.jpg": "eed1",
	"./overview_info1.jpg": "f80f",
	"./overview_info2.jpg": "30f8",
	"./overview_info3.jpg": "0d94",
	"./overview_infographic.jpg": "2b41",
	"./partner_ad.jpg": "be16",
	"./partner_bg.jpg": "df85",
	"./partner_kj.jpg": "d87c",
	"./partner_kn.jpg": "3b98",
	"./reference01.jpg": "0d70",
	"./reference02.jpg": "c794",
	"./reference03.jpg": "8545",
	"./reference04.jpg": "2174",
	"./reference05.jpg": "2277",
	"./reference06.jpg": "ee3d",
	"./reference07.jpg": "3ef1",
	"./reference08.jpg": "bad4",
	"./reference09.jpg": "f52b",
	"./reference10.jpg": "29ba",
	"./reference11.jpg": "be62",
	"./reference12.jpg": "63fd",
	"./reference13.jpg": "29bf",
	"./reference14.jpg": "b418",
	"./reference15.jpg": "4804",
	"./reference16.jpg": "b453",
	"./reference17.jpg": "f34c",
	"./reference18.jpg": "2e6a",
	"./reference19.jpg": "9448",
	"./reference20.jpg": "7dd8",
	"./reference21.jpg": "9d13",
	"./reference22.jpg": "c771",
	"./reference23.jpg": "b13b",
	"./reference24.jpg": "228a",
	"./reference25.jpg": "a41e",
	"./reference26.jpg": "97c1",
	"./reference27.jpg": "4945",
	"./reference28.jpg": "04f1",
	"./reference29.jpg": "4b38",
	"./reference30.jpg": "9a2f",
	"./reference31.jpg": "ffb7",
	"./reference32.jpg": "3d72",
	"./reference33.jpg": "ca9c",
	"./reference34.jpg": "ef80",
	"./reference35.jpg": "f1bf",
	"./reference36.jpg": "d57c",
	"./reference37.jpg": "b251",
	"./reference38.jpg": "cfc9",
	"./top_cognitive.jpg": "bb26",
	"./top_company.jpg": "f806",
	"./top_directions.jpg": "e2f5",
	"./top_game.jpg": "e0ad",
	"./top_happytable.jpg": "a49a",
	"./top_news.jpg": "3e20",
	"./top_overview.jpg": "e975",
	"./top_partner.jpg": "de39",
	"./top_reference.jpg": "9438"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84d8";